import { render, staticRenderFns } from "./TatDatePopover.vue?vue&type=template&id=6b319644"
import script from "./TatDatePopover.vue?vue&type=script&lang=js"
export * from "./TatDatePopover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports